import { connect } from "react-redux";
import { default as component } from "./EditUserProfileModal.jsx";

// actions
import { dismissModal } from "../../../common/UI/ActiveModal/duck/actions";

// selectors
import { getActiveModal } from "../../../common/UI/ActiveModal/duck/selectors";

// wrapper container
const MapStateToProps = (state) => {
  return {
    activeModal: getActiveModal(state),
  };
};

const MapDispatchToProps = {
  dismissModal,
};

export default connect(MapStateToProps, MapDispatchToProps)(component);
